<template>
  <v-snackbar
    :key="state.id"
    v-model="state.open"
    :color="state.type"
    :timeout="timeout"
    :z-index="2900"
    location="bottom right"
  >
    {{ state.message }}
  </v-snackbar>
</template>

<script>
import { MUTATION_FEEDBACK_TIMEOUT, mutationFeedbackState } from "@/Utile/mutationFeedback.mjs";

/** Montat o singură dată în `App.vue`; paginile apelează `notifyMutation(...)`, nu își mai redau propriul snackbar. */
export default {
  name: "AppFeedbackHost",
  data() {
    return { state: mutationFeedbackState, timeout: MUTATION_FEEDBACK_TIMEOUT };
  },
};
</script>
